import styled from "styled-components"

const StaticTrackerMap = styled.img`
  position: relative;
  width: 100%;
  border-radius: 6px;
`

const MapContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const GoogleMapWrapper = styled.div`
  width: 100%;
`

const orderMapContainerDimensions = {
  height: "100%",
  aspectRatio: "320 / 216",
  borderRadius: '6px',
  overflow: 'hidden',
}

export {
  StaticTrackerMap,
  MapContainer,
  GoogleMapWrapper,
  orderMapContainerDimensions,
}
